import React from 'react';
import { EventCloseCsvPageProvider } from '@/context/FinancialPageContext';
import { EventCloseCsvWrapper } from './EventCloseCsvWrapper';

export const EventCloseCsvScreen: React.FC = (): JSX.Element => (
  <EventCloseCsvPageProvider>
    <EventCloseCsvWrapper />
  </EventCloseCsvPageProvider>
);
